import $ from 'jquery';

class ExcelRange {
	
	constructor() {

		$(".excel-range").each((i, element) => {
			if ($(element).hasClass("initialized")) {
				return;
			}
			$(element).click(e => {
				e.preventDefault();
				let type = $(element).data("type");
                let name = $(element).data("name");


				this.modal({
					type: type,
					name: name
				});

			}).addClass("initialized");

		});

	}

	modal(data) {
		let div = $("<div></div>").addClass("modal fade");
		let dialog = $("<div></div>").addClass("modal-dialog");
		let contents = $("<div></div>").addClass("modal-content");
		let header = $("<div></div>").addClass("modal-header").html(
			'<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>'
			).append(
			$("<h4></h4>").html("Select Range").addClass("modal-title")
			);
		let body = $("<div></div>").addClass("modal-body").html($("<p></p>").html("Select Date Range"));

		let from = $("<input type=text class='form-control' />");
		let to = $("<input type=text class='form-control' />");

		
		let dates = $('<div class="input-group input-daterange"></div>');
		$(dates).append(from);
		$(dates).append('<div class="input-group-addon">to</div>')
			$(dates).append(to);
		
		$(dates).datepicker({
			format: 'yyyy-mm-dd'
		})
		
		$(body).append(dates);

		let footer = $("<div></div>").addClass("modal-footer");

		let cancel = $('<button type="button" class="btn btn-default">Close</button>');

		$(cancel).click(e => {
			e.preventDefault();
			$(div).modal('hide');
		});


		let ok = $('<button type="button" class="btn btn-primary">Download</button>');

		$(ok).click(e => {
			e.preventDefault();
			let f = $(from).val();
			let t = $(to).val();
			if (t && f) {
				window.location = '/excel/range/' + data.type + '?from=' + f + '&to=' + t;
				$(div).modal('hide');
			}
		});


		$(footer).html(cancel).append(ok);

		$(contents).html(header).append(body).append(footer);

		$(dialog).html(contents);
		$(div).html(dialog);


		$("body").append(div);


		$(div).on('hidden.bs.modal', function (e) {
		  $(div).remove();
		});

		$(div).modal('show');
		

	}


}

export default ExcelRange;
